import EmailChange from './EmailChange';

export default EmailChange;
